import styled from 'styled-components';

export const StyledAddResultInputsWrapper = styled.div``;
